import { warn } from '../../util/index'

export default {
  bind () {
    process.env.NODE_ENV !== 'production' && warn(
      'v-ref:' + this.arg + ' must be used on a child ' +
      'component. Found on <' + this.el.tagName.toLowerCase() + '>.',
      this.vm
    )
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/vue/src/directives/public/ref.js
// module id = ./node_modules/vue/src/directives/public/ref.js
// module chunks = 53